var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Body } from "@irati/ui/src/Typography";
import { FormattedCurrency, FormattedMessage } from "@irati/utils/lang";
var ProductList = function (_a) {
    var data = _a.data, breakdown = _a.breakdown;
    var products = breakdown.items.map(function (breakdownItem) {
        return __assign(__assign({}, breakdownItem), { item: __assign(__assign({}, breakdownItem.item), { product: data.find(function (product) { return product.uuid === breakdownItem.item.productId; }) }) });
    });
    return (React.createElement("div", { className: "orderSummaryProductList" },
        data.length > 0 &&
            products.map(function (_a) {
                var item = _a.item, total = _a.total;
                return (React.createElement("div", { className: "orderSummaryProductList__item", key: item.productId },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 2 },
                            React.createElement(Body, { small: true, weight: "bold", color: "ink" },
                                item.count || 1,
                                "x")),
                        React.createElement(Col, { xs: 6 },
                            React.createElement(Body, { small: true, weight: "bold", color: "ink" }, item.product.name)),
                        React.createElement(Col, { xs: 4 },
                            React.createElement("div", { className: "pull-right" },
                                React.createElement(Body, { small: true, weight: "bold", color: "ink" },
                                    total.originalPrice > 0 && React.createElement(FormattedCurrency, { value: total.originalPrice, currency: total.currency }),
                                    !total.originalPrice && React.createElement(FormattedMessage, { id: "perks.components.orderSummary.getTotal.free" })))))));
            }),
        data.length > 0 && React.createElement("hr", null)));
};
export default ProductList;
